import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PracticeAreas from './components/PracticeAreas';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <PracticeAreas />
      <ServicesSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
